<div class="container text-center">
  <p class="h2 mt-5">{{ SERVER_NAME }} World Bosses Rank</p>
  <br>

  <div *ngIf="service.encounters; else loading">
    <div class="mt-2">
      <strong>Boss: </strong>
      <select class="btn btn-default form-control select-boss" (change)="service.handleBoss($event.target.value)">
        <option *ngFor="let boss of BOSSES" [value]="boss.id">{{ boss.name }}</option>
      </select>
    </div>

    <div class="mt-3">
      <div class="table-responsive">

        <table class="table table-striped table-bordered">
          <thead>
            <th class="text-center">Character</th>
            <th class="text-center">Class</th>
            <th class="text-center">Race</th>
            <th class="text-center">Faction</th>
            <th class="text-center">Level</th>
            <th class="text-center">Date</th>
            <th class="text-center">Difficulty</th>
            <th class="text-center">Duration</th>
          </thead>
          <tbody>
            <tr *ngFor="let player of service.encounters" [ngClass]="player.faction">
              <td><strong>{{ player.name }}</strong></td>
              <td><img [src]="'assets/class/' + player.class + '.gif'"></td>
              <td><img [src]="'assets/race/' + player.race + '-' + player.gender + '.gif'"></td>
              <td><img [src]="'assets/' + player.faction + '_min.png'"></td>
              <td><strong>{{ player.level }}</strong></td>
              <td>{{ player.timeStamp }}</td>
              <td>{{ player.difficulty }}</td>
              <td>{{ player.duration }}</td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>
  </div>

  <ng-template #loading>
    <br>
    Loading data from API...
    <br>
  </ng-template>

  <br>
  <!-- I worked for free to build this software, please do not remove the credit! -->
  <p class="small">Designed by <a target="_blank" href="https://github.com/FrancescoBorzi/">ShinDarth</a> && <a target="_blank" href="https://github.com/Helias/">Helias</a></p>
</div>